import {
  LISTA_VERIFICACAO_IDENTIDADE,
  LISTA_VERIFICACAO_IDENTIDADE_SUCESSO,
  LISTA_VERIFICACAO_IDENTIDADE_ERRO,
  APROVA_VERIFICACAO_IDENTIDADE,
  APROVA_VERIFICACAO_IDENTIDADE_SUCESSO,
  REPROVA_VERIFICACAO_IDENTIDADE,
  REPROVA_VERIFICACAO_IDENTIDADE_SUCESSO,
  VERIFICACAO_IDENTIDADE_ERRO,
} from 'constants/ActionTypes';

const INIT_STATE = {
  carregando: false,
  enviando: false,
  items: [],
  total: 0,
  totalPaginas: 0,
  pagina: 1,
  tamanhoPagina: 20,
  statusFiltro: 'PENDENTE',
  erro: null,
  sucesso: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LISTA_VERIFICACAO_IDENTIDADE:
      return { ...state, carregando: true, erro: null, sucesso: false, statusFiltro: action.payload.status };

    case LISTA_VERIFICACAO_IDENTIDADE_SUCESSO:
      return {
        ...state,
        carregando: false,
        items: action.payload.items,
        total: action.payload.total,
        totalPaginas: action.payload.totalPaginas || Math.ceil(action.payload.total / action.payload.tamanhoPagina),
        pagina: action.payload.pagina,
        tamanhoPagina: action.payload.tamanhoPagina,
      };

    case LISTA_VERIFICACAO_IDENTIDADE_ERRO:
      return { ...state, carregando: false, erro: action.payload };

    case APROVA_VERIFICACAO_IDENTIDADE:
    case REPROVA_VERIFICACAO_IDENTIDADE:
      return { ...state, enviando: true, erro: null, sucesso: false };

    case APROVA_VERIFICACAO_IDENTIDADE_SUCESSO:
    case REPROVA_VERIFICACAO_IDENTIDADE_SUCESSO:
      return { ...state, enviando: false, sucesso: true };

    case VERIFICACAO_IDENTIDADE_ERRO:
      return { ...state, enviando: false, erro: action.payload };

    default:
      return state;
  }
};
